module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row color-legend offset",
    attrs: {
      "id": "drought_circle_legend"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 offset-sm-2 col-sm-5 offset-lg-1 col-lg-5 circle-legend"
  }, [_c('h3', {
    staticClass: "droughty"
  }, [_vm._v("Percentage of State at a Particular Drought Level")]), _vm._v(" "), _c('svg', {
    staticClass: "legend",
    attrs: {
      "width": "350",
      "height": "55"
    }
  }, [_c('text', {
    attrs: {
      "x": "1",
      "y": "35",
      "height": "30",
      "width": "25"
    }
  }, [_vm._v("\n        Smaller\n      ")]), _vm._v(" "), _c('g', {
    attrs: {
      "width": "350"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "60",
      "cy": "15",
      "r": "3",
      "transform": "translate(0,15)"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "width": "350"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "80",
      "cy": "15",
      "r": "8",
      "transform": "translate(0,15)"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "width": "350"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "110",
      "cy": "15",
      "r": "13",
      "transform": "translate(0,15)"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "width": "350"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "150",
      "cy": "15",
      "r": "18",
      "transform": "translate(0,15)"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "width": "350"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "200",
      "cy": "15",
      "r": "23",
      "transform": "translate(0,15)"
    }
  })]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "233",
      "y": "35",
      "height": "30",
      "width": "25"
    }
  }, [_vm._v("\n        Greater\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-4 col-lg-4 circle-legend"
  }, [_c('h3', {
    staticClass: "droughty"
  }, [_vm._v("Interpreting the Drought Circles")]), _vm._v(" "), _c('svg', {
    attrs: {
      "width": "325",
      "height": "100"
    }
  }, [_c('g', {
    staticClass: "color-legend",
    attrs: {
      "transform": "translate(35,25)"
    }
  }, [_c('circle', {
    staticStyle: {
      "stroke": "rgb(255, 255, 212)"
    },
    attrs: {
      "cx": "50",
      "cy": "15",
      "r": "30"
    }
  }), _vm._v(" "), _c('circle', {
    staticStyle: {
      "stroke": "rgb(254, 217, 142)"
    },
    attrs: {
      "cx": "50",
      "cy": "15",
      "r": "25"
    }
  }), _vm._v(" "), _c('circle', {
    staticStyle: {
      "stroke": "rgb(254, 153, 41)"
    },
    attrs: {
      "cx": "50",
      "cy": "15",
      "r": "20"
    }
  }), _vm._v(" "), _c('circle', {
    staticStyle: {
      "stroke": "rgb(217, 95, 14)"
    },
    attrs: {
      "cx": "50",
      "cy": "15",
      "r": "15"
    }
  }), _vm._v(" "), _c('circle', {
    staticStyle: {
      "stroke": "rgb(153, 52, 4)"
    },
    attrs: {
      "cx": "50",
      "cy": "15",
      "r": "10"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "annotations"
  }, [_c('g', {
    attrs: {
      "transform": "translate(125,100)"
    }
  }, [_c('text', {
    attrs: {
      "transform": "translate(11,-85)"
    }
  }, [_vm._v("\n            Abnormally Dry (D0)\n          ")]), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M-30,-89L5,-89"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "translate(125,100)"
    }
  }, [_c('text', {
    attrs: {
      "transform": "translate(11,-65)"
    }
  }, [_vm._v("\n            Moderate Drought (D1)\n          ")]), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M-18,-71L3,-71"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "translate(125,100)"
    }
  }, [_c('text', {
    attrs: {
      "transform": "translate(11,-45)"
    }
  }, [_vm._v("\n            Severe Drought (D2)\n          ")]), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M-21,-61L3,-52"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "translate(125,100)"
    }
  }, [_c('text', {
    attrs: {
      "transform": "translate(11,-25)"
    }
  }, [_vm._v("\n            Extreme Drought (D3)\n          ")]), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M-26,-56L4,-34"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "translate(125,100)"
    }
  }, [_c('text', {
    attrs: {
      "transform": "translate(11,-5)"
    }
  }, [_vm._v("\n            Exceptional Drought (D4)\n          ")]), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M-36,-51L5,-14"
    }
  })])])])]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12 col-lg-12"
  }, [_c('h3', {
    staticClass: "droughty text-center offset"
  }, [_vm._v("Drought Effects")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 offset-sm-3 col-sm-9 offset-lg-3 col-lg-8"
  }, [_c('p', [_vm._v("The "), _c('a', {
    staticClass: "inside",
    attrs: {
      "href": "http://droughtmonitor.unl.edu/AboutUs/ClassificationScheme.aspx"
    }
  }, [_vm._v("United States Drought\n        Monitor")]), _vm._v(" defines the effects of various drought levels as follows:")]), _vm._v(" "), _c('ul', {
    staticClass: "list-unstyled"
  }, [_c('li', [_vm._v("DO\n          "), _c('ul', [_c('li', [_vm._v("Short-term dryness slowing planting, growth of crops or pastures")])])]), _vm._v(" "), _c('li', [_vm._v("D1\n          "), _c('ul', [_c('li', [_vm._v("Some damage to crops, pastures")]), _vm._v(" "), _c('li', [_vm._v("Streams, reservoirs, or wells low, some water shortages developing or imminent")]), _vm._v(" "), _c('li', [_vm._v(" Voluntary water-use restrictions requested")])])]), _vm._v(" "), _c('li', [_vm._v("D2\n          "), _c('ul', [_c('li', [_vm._v("Crop or pasture losses likely")]), _vm._v(" "), _c('li', [_vm._v("Water shortages common")]), _vm._v(" "), _c('li', [_vm._v("Water restrictions imposed")])])]), _vm._v(" "), _c('li', [_vm._v("D3\n          "), _c('ul', [_c('li', [_vm._v("Major crop/pasture losses")]), _vm._v(" "), _c('li', [_vm._v("Widespread water shortages or restrictions")])])]), _vm._v(" "), _c('li', [_vm._v("D4\n          "), _c('ul', [_c('li', [_vm._v("Exceptional and widespread crop/pasture losses")]), _vm._v(" "), _c('li', [_vm._v("Shortages of water in reservoirs, streams, and wells creating water emergencies")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40d596cf"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DroughtLegendChart.vue
// module id = 373
// module chunks = 1